/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/


export type ListingSortOption = typeof ListingSortOption[keyof typeof ListingSortOption];


export const ListingSortOption = {
  SALES_PRICE_DESC: 'SALES_PRICE_DESC',
  SALES_PRICE_ASC: 'SALES_PRICE_ASC',
  DISPLAY_ID_FROM_FILTER: 'DISPLAY_ID_FROM_FILTER',
  LISTING_ID_FROM_FILTER: 'LISTING_ID_FROM_FILTER',
  RENT_DESC: 'RENT_DESC',
  RENT_ASC: 'RENT_ASC',
  CREATED_AT_DESC: 'CREATED_AT_DESC',
  CREATED_AT_ASC: 'CREATED_AT_ASC',
  LIVING_SURFACE_DESC: 'LIVING_SURFACE_DESC',
  LIVING_SURFACE_ASC: 'LIVING_SURFACE_ASC',
  TOTAL_SURFACE_ASC: 'TOTAL_SURFACE_ASC',
  TOTAL_SURFACE_DESC: 'TOTAL_SURFACE_DESC',
  PUBLISHED_AT_DESC: 'PUBLISHED_AT_DESC',
  PUBLISHED_AT_ASC: 'PUBLISHED_AT_ASC',
  PROPERTY_KIND_DESC: 'PROPERTY_KIND_DESC',
  PROPERTY_KIND_ASC: 'PROPERTY_KIND_ASC',
  BUSINESS_AREA_DESC: 'BUSINESS_AREA_DESC',
  BUSINESS_AREA_ASC: 'BUSINESS_AREA_ASC',
  PROPERTY_MARKETING_TYPE_DESC: 'PROPERTY_MARKETING_TYPE_DESC',
  PROPERTY_MARKETING_TYPE_ASC: 'PROPERTY_MARKETING_TYPE_ASC',
  PREFERENCES: 'PREFERENCES',
} as const;
